import { useContext } from 'react';
import { StateContext } from '../providers/AppStateProvider';

export function useAppState() {
  const context = useContext(StateContext);
  if (!context) {
    throw new Error('useAppState must be used within the AppStateProvider');
  }
  return context;
}
